export default "__VITE_ASSET__DfUIWSBt__"